import { QueryKey } from 'query';

export const PRESETS = 'presets';

export const presetsKey = new QueryKey(PRESETS);

export const screenPresets = presetsKey.exact();

export const mutations = presetsKey.mutations();

export const create = mutations.mutate('create');
export const update = mutations.mutate('update');
export const rename = mutations.mutate('rename');
export const remove = mutations.mutate('remove');
